import { useState } from "react";
import SStations from "./SStations";
import SWorkflows from "./SWorkflows";

/**
 * Products -> Workflow (user, 2026-10-30; Stations was its own tab):
 *   All Workflows  the workflow per product style (SWorkflows)
 *   Stations  the stations every workflow step picks from (SStations)
 *
 * initialTab "stations" opens Stations (old ?active=stations links).
 */
const SUB_TABS = [
  { id: "workflows", label: "All Workflows" },
  { id: "stations", label: "Stations" },
];

export default function WorkflowLayout({ initialTab = "workflows" }) {
  const [tab, setTab] = useState(initialTab);
  return (
    <div>
      <div className="btn-group mb-2" role="group" aria-label="Workflow">
        {SUB_TABS.map((t) => (
          <button
            key={t.id}
            type="button"
            className={`btn btn-sm border-primary ${
              tab === t.id ? "btn-primary" : "bg-white text-primary"
            }`}
            onClick={() => setTab(t.id)}
          >
            {t.label}
          </button>
        ))}
      </div>
      {tab === "stations" ? <SStations /> : <SWorkflows />}
    </div>
  );
}
